/* global window */

import $ from 'jquery';
import get from 'lodash/get';

import './TestArticles.scss';
import template from './TestArticles.vhtml';

const imageUrl = url => `url( '${url}' )`;

const currentLanguage = window.siteData.language || 'da';

export default {
	name: 'TestArticles',
	template: template,
	data: () => ({
		articles: [],
	}),
	props: {
		icon: {
			type: String,
			default: ''
		},
		headline: {
			type: String,
		},
		subheadline: {
			type: String,
		},
		articleIds: {
			type: Array,
		},
		link: {
			type: Object,
		},
	},
	created() {
		getArticles(this.articleIds)
			.then(result => this.articles = get(result, 'data', []));
	},
	methods: {
		imageUrl: imageUrl,
	},
};

function getArticles(articleIds) {
	const params = {
		includes: articleIds.join(','),
		lang: currentLanguage,
		'_': '1.5',
	};

	return $.get(`/wp-json/be/v1/article`, params);
}
